import PropTypes from 'prop-types';
import { COUNTRY_CODES } from '../constants';

export default PropTypes.oneOf(Object.values(COUNTRY_CODES));
